import type { ModuleManifest } from "@crialume/sdk";

import home from "@crialume/module-home/manifest";
import moldes from "@crialume/module-moldes/manifest";
import studio from "@crialume/module-studio/manifest";
import usuarios from "@crialume/module-usuarios/manifest";
import leads from "@crialume/module-leads/manifest";
// plop:append-import

/**
 * Módulos que compõem ESTE build. Lista explícita (em vez de glob por pasta):
 * - o grafo de dependências do pnpm fica honesto (shell depende do módulo);
 * - dá para montar builds diferentes só editando esta lista;
 * - só o manifesto entra no bundle inicial — o código vem pelo `loader`.
 *
 * `pnpm generate` adiciona novos módulos aqui automaticamente.
 */
export const manifests: ModuleManifest[] = [
  home,
  studio,
  moldes,
  usuarios,
  leads,
  // plop:append-module
];
